import { render } from "./LoadingSpinner.vue?vue&type=template&id=3d12d2ab&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=3d12d2ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d12d2ab"]])

export default __exports__